module.exports = __webpack_public_path__ + "236878cf36edd206f852c1c86a98ec2c.svg";